import { INPUT_FIELD_CLASSNAME } from '@/constants/classname/classname'
import { ChangeEvent, FunctionComponent } from 'react'

interface MinutesInputProp {
    disabled?: boolean
    onChange(event: ChangeEvent<HTMLInputElement>): void
    value: string
}

export const MinutesSelect: FunctionComponent<MinutesInputProp> = (props) => {
    return (
        <input
            className={INPUT_FIELD_CLASSNAME + ' w-[80px]'}
            disabled={props.disabled}
            type='Number'
            value={props.value}
            onChange={props.onChange}
            min={0}
            max={59}
        />
    )
}
